import {
    API_ENDPOINTS
} from '../constants';
import {
    getAuthToken
} from './account';

export const getSession = async () => {
    const request = await fetch(API_ENDPOINTS.sessions('DB_SETUP-5'), {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            'Content-Type': 'application/json',
        },
        method: 'GET'
    });
    return request.json();
};

export const updateSession = async (session: any) => {
    return fetch(API_ENDPOINTS.sessions('DB_SETUP-5'), {
        body: JSON.stringify(session),
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            'Content-Type': 'application/json'
        },
        method: 'POST',
    });
};


// WEBPACK FOOTER //
// ./src/services/session.ts